import{t as e}from"../../../../_virtual/index16.js";var r,t;r=e,t=e.exports,Object.defineProperty(t,"__esModule",{value:!0}),t.default=function(e){if(null===e||!0===e||!1===e)return NaN;var r=Number(e);return isNaN(r)?r:r<0?Math.ceil(r):Math.floor(r)},r.exports=t.default;
//# sourceMappingURL=index.js.map
